// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M13.324 3.842L9.95.676a.561.561 0 10-.772.817l2.346 2.216h-3.83c-.955-.064-1.84.33-2.513.996A3.558 3.558 0 004.125 7.25v2.041c0 .311.252.542.563.542s.562-.209.562-.52V7.25c0-.665.256-1.285.721-1.746.458-.452 1.034-.715 1.716-.691h3.835L9.176 7.029a.561.561 0 00-.023.795c.11.096.26.176.409.176.138 0 .277-.05.386-.154l3.375-3.166c.114-.128.177-.275.177-.43s-.063-.302-.176-.408zM8.438 9.5a.559.559 0 00-.563.541v1.104c0 .104-.084.167-.188.167H1.313c-.103 0-.187-.085-.187-.167V4.813c0-.104.084-.167.188-.167h1.312c.31 0 .563-.252.563-.541a.559.559 0 00-.563-.542H1.312A1.31 1.31 0 000 4.855v6.354A1.31 1.31 0 001.313 12.5h6.375A1.31 1.31 0 009 11.209v-1.104c0-.352-.25-.605-.563-.605z" />
        </svg>
    );
};

export default React.memo(Share);
